import React, { useEffect ,useRef } from "react";
import { createSwapy } from "swapy";

// Componentes
import StatSquare from "./StatSquare";

// Sample usage of StatSquare


export default function StatsNumericos({ statsData = []}) {
  const swapy = useRef(null);
  const swapySection = useRef(null);

  useEffect(() => {
    // If container element is loaded
    if (swapySection.current) {
      swapy.current = createSwapy(swapySection.current, {
        animation: "dynamic",
        enabled: true,
        swapMode: "drop",
        // autoScrollOnDrag: true,
      });

      // Your event listeners - Función de swapy para detectar el fin del swap
      swapy.current.onSwapEnd((event) => {
        console.log("swap", event);
      });
    }

    return () => {
      // Destroy the swapy instance on component destroy
      swapy.current?.destroy();
    };
  }, []);
  return (
    <div className="flex flex-col justify-center w-full">
      <div
        ref={swapySection}
        className="grid grid-cols-1 md:grid-cols-12 grid-rows-auto gap-4"
      >
        {statsData.map((stat, index) => (
          <div
          key={index}
            data-swapy-slot={`slot-${index}`}
            className={`group relative bg-aw-bluegray/50 rounded-2xl ${stat.gridClass}`}
          >
            <StatSquare
              key={index}
              icon={stat.icon}
              label={stat.label}
              value={stat.value}
              change={stat.change}
              iconBg={stat.iconBg}
              iconColor={stat.iconColor}
              dataSwapItem={`slot-${index}`}
              pillColor={stat.pillColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
